import DropDownDescription from '../Components/UI/DropDownDescription'
import Tabs from '../Components/UI/Tabs'
import useGet from '../Hooks/useGet'
import API_ENDPOINTS from '../Config/api'
import DescriptionBanner from '../Components/DescriptionBanner'
import CredenzialiEsposteTable from '../Components/Table/CredenzialiEsposteTable1'
import SuperficieEsternaEspostaTable from '../Components/Table/SuperficieEsternaEspostaTable1'
import CyberSurveillanceDashboard, { CyberSurveillanceStats } from '../Components/CyberSurveillanceDashboard2'
import VulnerabilityCharts from '../Components/VulnerabilityCharts'
import ClipLoader from 'react-spinners/ClipLoader'
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react'
import { useRecoilValue } from 'recoil';
import { disableForEnterpriseAtom } from '../Atom/disableForEnterpriseAtom';

export default function CyberSurveillance() {

    const { t } = useTranslation();
    const disableForEnterprise = useRecoilValue(disableForEnterpriseAtom)

    const [cyberSurveillanceVulnerability, setCyberSurveillanceVulnerability] = useState()
    const { fetchedData: cyberSurveillanceVulnerabilityAPI } = useGet(`${API_ENDPOINTS.cyberSurveillanceVulnerability}?stato=non_risolte`);
    useEffect(() => { setCyberSurveillanceVulnerability(cyberSurveillanceVulnerabilityAPI) }, [cyberSurveillanceVulnerabilityAPI])

    // Recupera TUTTE le vulnerabilità per i grafici (senza paginazione)
    const [allVulnerabilities, setAllVulnerabilities] = useState([])
    const { fetchedData: allVulnerabilitiesAPI } = useGet(`${API_ENDPOINTS.cyberSurveillanceVulnerability}?page_size=1000`);
    useEffect(() => { 
        if (allVulnerabilitiesAPI?.results) {
            setAllVulnerabilities(allVulnerabilitiesAPI.results)
        }
    }, [allVulnerabilitiesAPI])

    // Callback per aggiornare anche allVulnerabilities quando la tabella aggiorna
    const handleVulnerabilityUpdate = (updatedData) => {
        setCyberSurveillanceVulnerability(updatedData);
        // Aggiorna anche allVulnerabilities con i cambiamenti
        if (updatedData?.results) {
            setAllVulnerabilities(prev => 
                prev.map(v => {
                    const updated = updatedData.results.find(u => u.id === v.id);
                    return updated || v;
                })
            );
        }
    }

    const [cyberSurveillanceStats, setCyberSurveillanceStats] = useState()
    const { fetchedData: cyberSurveillanceStatsAPI } = useGet(API_ENDPOINTS.cyberSurveillanceStats);
    useEffect(() => { setCyberSurveillanceStats(cyberSurveillanceStatsAPI) }, [cyberSurveillanceStatsAPI])

    const [credenzialiEsposte, setCredenzialiEsposte] = useState()
    const { fetchedData: credenzialiEsposteAPI } = useGet(API_ENDPOINTS.listCredenzialiEsposte);
    useEffect(() => { setCredenzialiEsposte(credenzialiEsposteAPI) }, [credenzialiEsposteAPI])


    const { fetchedData: cyberSurveillanceResult } = useGet(API_ENDPOINTS.cyberSurveillance);

    const loader = <div className='w-full h-full flex justify-center items-center'><ClipLoader size={40} /></div>

    const tabsData = [
        {
            label: t('cyber_surveillance.surface'),
            children: <SuperficieEsternaEspostaTable
                data={cyberSurveillanceVulnerability}
                setData={handleVulnerabilityUpdate}
                disableForEnterprise={disableForEnterprise}
            />,
        },
        {
            label: t('cyber_surveillance.exposedCredentials'),
            children: <CredenzialiEsposteTable
                data={cyberSurveillanceStats}
                setData={setCyberSurveillanceStats}
                subData={credenzialiEsposte}
                setSubData={setCredenzialiEsposte}
                disableForEnterprise={disableForEnterprise}
            />,
        },
    ];

    const credenzialiEsposteChildren = (
        <div className="space-y-4">
            <p className="font-bold">{t('cyber_surveillance.risk_analysis')}</p>
            <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
                {[1, 2, 3, 4].map((i) => (
                    <li key={i}>
                        <p className='font-semibold'>{t(`cyber_surveillance.exposed.item${i}.title`)}</p>
                        <p className="mt-1">{t(`cyber_surveillance.exposed.item${i}.text`)}</p>
                    </li>
                ))}
            </ul>

            <p className="font-bold">{t('cyber_surveillance.solutions.title')}</p>
            <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
                {[1, 2, 3, 4].map((i) => (
                    <li key={i}>
                        <p className='font-semibold'>{t(`cyber_surveillance.solutions.exposed.s${i}.title`)}</p>
                        <p className="mt-1">{t(`cyber_surveillance.solutions.exposed.s${i}.text`)}</p>
                    </li>
                ))}
            </ul>
        </div>
    );

    const vulnerabilitàRilevteChildren = (
        <div className="space-y-4">
            <p className="font-bold">{t('cyber_surveillance.risk_analysis')}</p>
            <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
                {[1, 2, 3, 4].map((i) => (
                    <li key={i}>
                        <p className='font-semibold'>{t(`cyber_surveillance.vuln.item${i}.title`)}</p>
                        <p className="mt-1">{t(`cyber_surveillance.vuln.item${i}.text`)}</p>
                    </li>
                ))}
            </ul>

            <p className="font-bold">{t('cyber_surveillance.solutions.title')}</p>
            <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
                {[1, 2, 3, 4].map((i) => (
                    <li key={i}>
                        <p className='font-semibold'>{t(`cyber_surveillance.solutions.vuln.s${i}.title`)}</p>
                        <p className="mt-1">{t(`cyber_surveillance.solutions.vuln.s${i}.text`)}</p>
                    </li>
                ))}
            </ul>
        </div>
    );


    return (
        <div className="space-y-3 sm:space-y-6 px-2 sm:px-6 items-stretch">
            <div>
                <DescriptionBanner title='Cyber Surveillance' description={t('DescrBann_CyberSurveillance')} />
            </div>

            {/* Sezione totali a tutta larghezza */}
            <div data-tour="surveillance-dashboard">
            {cyberSurveillanceResult ? <CyberSurveillanceDashboard cyberSurveillanceResult={cyberSurveillanceResult} /> : (cyberSurveillanceResult === null ? <div className='text-center py-8 text-gray-500'>Nessun dato disponibile da caricare in questa sezione</div> : loader)}
            </div>

            {/* Sezione minacce e grafici */}
            <div data-tour="surveillance-stats">
            {cyberSurveillanceResult && allVulnerabilities && allVulnerabilities.length > 0 ? (
                <div className="w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 sm:gap-4 md:gap-6 auto-rows-fr">
                        {/* Stats minacce - card individuali che occupano 1 colonna ciascuna */}
                        <CyberSurveillanceStats cyberSurveillanceResult={cyberSurveillanceResult} />
                        
                        {/* Grafici - card individuali che occupano 1 colonna ciascuna */}
                        <VulnerabilityCharts 
                            key={JSON.stringify(allVulnerabilities.map(v => `${v.id}-${v.status}`))}
                            vulnerabilities={allVulnerabilities} 
                        />
                    </div>
                </div>
            ) : allVulnerabilitiesAPI ? (
                <div className="text-center py-8 text-gray-500">
                    Nessuna vulnerabilità disponibile per generare le statistiche
                </div>
            ) : loader}
            </div>

            <div data-tour="surveillance-tabs">
            <Tabs tabs={tabsData} />
            </div>

            <div className='space-y-4' data-tour="surveillance-criticality">
                <p className="text-xl font-bold">
                    {t('cyber_surveillance.criticality_areas')}
                </p>
                <DropDownDescription title={t('cyber_surveillance.exposedCredentials')} dropDownChildren={credenzialiEsposteChildren} />
                <DropDownDescription title={t('cyber_surveillance.vulnerabilitiesFound')} dropDownChildren={vulnerabilitàRilevteChildren} />
            </div>
        </div>
    )
}

const credenzialiEsposteChildren = (
    <div className="space-y-4">
        <p className="font-bold">Analisi del rischio</p>
        <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
            <li>
                <p className='font-semibold'>Accesso non autorizzato immediato</p>
                <p className="mt-1">
                    Username + password trapelate in dump pubblici permettono login diretti su posta, VPN o SaaS prima che l’azienda se ne accorga.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Escalation interna</p>
                <p className="mt-1">
                    Con un singolo account compromesso l’attaccante può muoversi lateralmente, rubare ulteriori credenziali (token, cookie) e puntare a sistemi OT.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Frodi e-mail e phishing mirato</p>
                <p className="mt-1">
                    L’uso di credenziali reali rende le campagne di phishing molto più credibili, aumentando il tasso di click e di truffe BEC.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Danni reputazionali e multe GDPR</p>
                <p className="mt-1">
                    Se gli account contengono dati personali di clienti o fornitori, la violazione va notificata entro 72 h con potenziali sanzioni.
                </p>
            </li>
        </ul>

        <p className="font-bold">Soluzioni consigliate</p>
        <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
            <li>
                <p className='font-semibold'>Reset forzato e MFA obbligatoria</p>
                <p className="mt-1">
                    per tutti gli utenti; ritiro di sessioni attive sui servizi cloud.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Monitoraggio continuo di data-leak</p>
                <p className="mt-1">
                    con alert automatici su nuove esposizioni di dominio*@azienda.com.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Password manager + policy di rotazione</p>
                <p className="mt-1">
                    (min. 14 caratteri, univoche per servizio).
                </p>
            </li>
            <li>
                <p className='font-semibold'>Simulazione di phishing mirata</p>
                <p className="mt-1">
                    ai reparti colpiti e training su riconoscimento di BEC.
                </p>
            </li>
        </ul>

        {/* <p className="text-sm">
            Per avere una consulenza approfondita, compila il <a href="#form" className="text-yellow-600 underline">form</a> e verrai contattato da un nostro esperto!
        </p>
        <p className="text-sm">
            Per una lista di strumenti consigliati vai alla tabella det <p>task</p>!
        </p> */}
    </div>
);

const vulnerabilitàRilevteChildren = (
    <div className="space-y-4">
        <p className="font-bold">Analisi del rischio</p>
        <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
            <li>
                <p className='font-semibold'>Sfruttamento automatico (exploit kit)</p>
                <p className="mt-1">
                    Le CVE critiche pubblicate con PoC permettono attacchi massivi “spray-and-pray” in poche ore.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Pivot verso la rete interna</p>
                <p className="mt-1">
                    Un servizio web vulnerabile funge da trampolino per enumerare Active Directory o accedere a repository di progetto.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Interruzione dei servizi essenziali</p>
                <p className="mt-1">
                    Exploit su VPN, firewall o ERP può bloccare produzione e fornitori just-in-time.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Perdita di conformità</p>
                <p className="mt-1">
                    Dimostrare patching tempestivo è requisito ISO 27001/TISAX; CVE aperte indeboliscono audit e assicurazioni cyber.
                </p>
            </li>
        </ul>

        <p className="font-bold">Soluzioni consigliate</p>
        <ul className="list-disc list-outside pl-5 space-y-2 text-sm text-gray-700">
            <li>
                <p className='font-semibold'>Patching a finestra ≤ 72 h</p>
                <p className="mt-1">
                    per CVE con CVSS ≥ 9 o con exploit pubblico; rolling-update per cluster dove possibile.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Virtual patch (WAF/IPS)</p>
                <p className="mt-1">
                    se l’aggiornamento non è immediatamente disponibile.
                </p>
            </li>
            <li>
                <p className='font-semibold'>Scansione settimanale</p>
                <p className="mt-1">
                    dei servizi esterni e integrazione con ticketing (owner, ETA, evidenza di chiusura).
                </p>
            </li>
            <li>
                <p className='font-semibold'>Regola “no exposure by default”</p>
                <p className="mt-1">
                    pubblicare solo ciò che serve, dietro reverse-proxy, con autenticazione e TLS.
                </p>
            </li>
        </ul>

        {/* <p className="text-sm">
            Per avere una consulenza approfondita, compila il <a href="#form" className="text-yellow-600 underline">form</a> e verrai contattato da un nostro esperto!
        </p>
        <p className="text-sm">
            Per una lista di strumenti consigliati vai alla tabella det <p>task</p>!
        </p> */}
    </div>

);
